export const anchorScroll = () => {
  const urlHash = location.hash;
  const header = document.getElementById("header");
  const headerHeight = 0;

  if (urlHash) {
    window.scrollTo(0, 0);
    setTimeout(() => {
      const target = document.querySelector(urlHash);
      if (target) {
        const position = target.offsetTop - headerHeight;
        window.scrollTo({
          top: position,
          behavior: "smooth",
        });
      }
    }, 500);
  }

  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener("click", (e) => {
      const href = link.getAttribute("href");
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        const position = target.offsetTop - headerHeight;
        window.scrollTo({
          top: position,
          behavior: "smooth",
        });
      }
    });
  });
};
